// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.vrm-details-container .vrm-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.vrm-details-container .header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.vrm-details-container .title-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vrm-details-container .section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ceoTrackTitleColor);
  margin: 0;
}

.vrm-details-container .edit-title {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: var(--secondary-FontColour);
  font-weight: 600;
  user-select: none;
  font-size: 16px;
}

.vrm-details-container .edit-title.editing {
  cursor: default;
  color: var(--button-disabled-color);
}

.vrm-details-container .vrm-edit-icon {
  height: 20px;
  width: 20px;
}

.vrm-details-container .vrm-input-row {
  margin-bottom: 12px;
}
.vrm-details-container .vrm-input-row .text-field-container .colWiseControl {
  gap: 0px;
}

.vrm-details-container .button-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end; /* Align buttons to right */
}

.vrm-details-container .textbox .vrm-input .MuiInputBase-root {
  height: 80px;
  border-radius: 8px;
  background: var(--vrm-container-color);
  color: var(--ceoTrackTitleColor);
  font-size: 66px;
  border: 1px solid;
  font-weight: 600;
}
.textbox .vrm-input .MuiInputBase-root.MuiInput-root.Mui-disabled {
  background-color: var(--vrm-container-color) !important;
  color: var(--ceoTrackTitleColor) !important;
}
.textbox .vrm-input .MuiInputBase-root input {
  text-align: center;
  height: 90%;
  line-height: 1;
  padding: 0;
}

.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill,
.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill:hover,
.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--ceoTrackTitleColor) !important;
  -webkit-box-shadow: 0 0 0 1000px var(--vrm-container-color) inset !important;
  caret-color: var(--ceoTrackTitleColor);
}
.vrm-section .header-row .vrm-icon {
  width: 36px;
  height: 21px;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/VRMSection/VRMSection.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;;;EAGE,6DAA6D;EAC7D,4EAA4E;EAC5E,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.vrm-details-container .vrm-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.vrm-details-container .header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.vrm-details-container .title-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.vrm-details-container .section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ceoTrackTitleColor);\n  margin: 0;\n}\n\n.vrm-details-container .edit-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: var(--secondary-FontColour);\n  font-weight: 600;\n  user-select: none;\n  font-size: 16px;\n}\n\n.vrm-details-container .edit-title.editing {\n  cursor: default;\n  color: var(--button-disabled-color);\n}\n\n.vrm-details-container .vrm-edit-icon {\n  height: 20px;\n  width: 20px;\n}\n\n.vrm-details-container .vrm-input-row {\n  margin-bottom: 12px;\n}\n.vrm-details-container .vrm-input-row .text-field-container .colWiseControl {\n  gap: 0px;\n}\n\n.vrm-details-container .button-row {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end; /* Align buttons to right */\n}\n\n.vrm-details-container .textbox .vrm-input .MuiInputBase-root {\n  height: 80px;\n  border-radius: 8px;\n  background: var(--vrm-container-color);\n  color: var(--ceoTrackTitleColor);\n  font-size: 66px;\n  border: 1px solid;\n  font-weight: 600;\n}\n.textbox .vrm-input .MuiInputBase-root.MuiInput-root.Mui-disabled {\n  background-color: var(--vrm-container-color) !important;\n  color: var(--ceoTrackTitleColor) !important;\n}\n.textbox .vrm-input .MuiInputBase-root input {\n  text-align: center;\n  height: 90%;\n  line-height: 1;\n  padding: 0;\n}\n\n.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill,\n.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill:hover,\n.textbox .vrm-input .MuiInputBase-root input:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--ceoTrackTitleColor) !important;\n  -webkit-box-shadow: 0 0 0 1000px var(--vrm-container-color) inset !important;\n  caret-color: var(--ceoTrackTitleColor);\n}\n.vrm-section .header-row .vrm-icon {\n  width: 36px;\n  height: 21px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
